export default "__VITE_ASSET__DTDktWLj__"